
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import BlocTextForm from '@/components/forms/MailBlocTextForm.vue'
import VueScrollTo from 'vue-scrollto'

const mailModule = namespace('mail')

@Component({
  components: {
    BaseCardContainer,
    BlocTextForm
  }
})
export default class BlocTextUpdate extends Vue {
  @mailModule.Action('getMailBlocTextByIdAction') getMailBlocTextById: any
  @mailModule.Action('getMailBlocTextsAction') getMailBlocTexts: any
  @mailModule.Action('updateMailBlocTextAction') updateMailBlocText: any
  @mailModule.Getter('mailBlocTextGetter') mailBlocText: any

  mounted() {
    this.getMailBlocTextById(this.$route.params.id)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.id', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getMailBlocTextById(newVal)
  }

  onSubmit(data: any) {
    this.updateMailBlocText({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getMailBlocTexts()
      this.$router.push({name: 'BlocTextList'})
    })
  }

  onCancel() {
    this.$router.push({name: 'BlocTextList'})
  }
}
